import { ReactElement } from 'react';

import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { GoToPatientsFileDropdownItem } from '~legacy.patient';

import { visitTranslationKeys } from '../../../../translations';

type PatientFileDropdownItemProps = {
   readonly patientId: VisitAndAppointmentView['patientId'];
};
export const PatientFileDropdownItem = (props: PatientFileDropdownItemProps): ReactElement => {
   return (
      <GoToPatientsFileDropdownItem
         patientId={props.patientId}
         addToStack={false}
         locationState={{
            label: visitTranslationKeys.goBackToAppointmentsList,
         }}
      />
   );
};
